'use strict';
import { htmlNews } from "../functions.js";

document.addEventListener('DOMContentLoaded', () => {
  const buttonMoreNews = document.querySelector('#js-more-news');
  if(buttonMoreNews) {
    let page = buttonMoreNews.getAttribute('data-page');
    buttonMoreNews.addEventListener('click', () => {
      buttonMoreNews.setAttribute('disabled', 'disabled');

      let formData = new FormData();
      formData.append('action', 'news');
      formData.append('postPerPage', buttonMoreNews.getAttribute('data-per-page'));
      formData.append('page', page);

      fetch(themeVar.url, {
        method: 'POST',
        body: formData,
      })
      .then(response => response.json())
      .then(data => {
        buttonMoreNews.removeAttribute('disabled');
        page++;
        if(!data.continue) {
          buttonMoreNews.remove();
        }

        const containerAppend = document.querySelector('#js-append-news');
        htmlNews(data.news, containerAppend);
      });
    });
  }
});